// import logo from './logo.svg';
// import './App.css';
import Redirect from './redirect';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

const TempRedirect = () => (
  <Redirect url="https://open.spotify.com/playlist/4uAAA4IuASFSRsuwusrYmf" />
)

//export default App;
export default TempRedirect;
